var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-chart"},[(!_vm.series.length)?_c('div',{staticClass:"text-muted fs-sm py-2"},[_vm._v("\n    "+_vm._s(_vm.emptyText)+"\n  ")]):_c('div',{staticClass:"report-chart-canvas",style:({ height: _vm.canvasHeight })},[_c('canvas',{ref:"canvas",attrs:{"role":"img","aria-label":_vm.summary}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }